import React, { useEffect, useState } from "react";
import "./training-client.scss";
import { withRouter } from "react-router";
import { scheduleRequest } from "../../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../../../components/spinner";
import {
  getChildScheduleSelector,
  getScheduleGroupForClientSelector,
} from "../../../../selectors/schedule-selectors";
import { Link } from "react-router-dom";
import Refresh from "../../../../icons-office/refresh.svg";
import Arrow from "../../../../icons-office/arrow.svg";
import StatusTraining from "../../../../.TrainerOffice/components/main/component/status-training";
import { NewDate } from "../../../../components/history-list/history-list";
import { addEventSchedule } from "../../../../store/actions/trainer";
import DialogActions from "@material-ui/core/DialogActions/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "../../../../.TrainerOffice/components/hoc/dialog-title";
import DialogContent from "@material-ui/core/DialogContent";
import SelectReact from "react-select";
import CircularProgress from "@material-ui/core/CircularProgress";
import { requestGroupScheduleForClientTraining } from "../../../../store/actions/selects";
import { trainingMoveInvoice } from "../../../../store/actions/invoice";

export const CircularIndeterminate = () => {
  return (
    <div className="spinnerClientTraining">
      <CircularProgress />
    </div>
  );
};

export const customStylesClient = {
  singleValue: (styles) => ({ ...styles, color: "#858585", fontSize: "12px" }),
  control: (styles) => ({
    ...styles,
    padding: 0,
    backgroundColor: "inherit",
    height: "25px",
    minHeight: "25px",
  }),
  option: (styles) => ({
    ...styles,
    fontSize: "12px",
    padding: "0 0 5px 5px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    backgroundColor: "white",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "25px",
    padding: 0,
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    display: "none",
  }),
};

const TrainingClient = (props) => {
  const { id } = props.match.params;
  const { child_id } = props.location.state;
  const { child } = props.location.state;
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.trainer.scheduleLoading);
  const loadingGroupSchedule = useSelector(
    (state) => state.selects.scheduleGroupLoading
  );
  const user = useSelector((state) => state.auth.user);
  const schedule = useSelector((state) => getChildScheduleSelector(state));
  const scheduleGroup = useSelector((state) =>
    getScheduleGroupForClientSelector(state, child)
  );
  const [content, setContent] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedDay, setSelectedDay] = useState("");

  useEffect(() => {
    if (scheduleGroup.length) {
      setSelectedDay(scheduleGroup[0]);
    }
  }, [scheduleGroup]);
  useEffect(() => {
    dispatch(scheduleRequest(id));
    document.title = "Тренировка";
  }, [dispatch, id]);

  const addEvent = () => {
    const payload = {
      content,
      id: Number(id),
    };
    const required = "schedule";
    dispatch(addEventSchedule(required, payload));
    setContent("");
  };

  const moveTraining = () => {
    const data = {
      training_from_id: schedule.training.find(
        (item) => item.children.id === child.id
      ).id,
      schedule_to_id: selectedDay.id,
    };
    dispatch(trainingMoveInvoice(data));
    setOpen(!open);
    setSelectedDay("");
  };

  const colorContainerEvent = (creator) => {
    if (creator === user.full_name) {
      return { border: "1px solid #81CC5E" };
    } else return { border: "1px solid #4594CC" };
  };

  const openGroupSchedule = () => {
    setOpen(!open);
    dispatch(requestGroupScheduleForClientTraining(schedule.group.id));
  };

  if (loading) {
    return <Spinner open={loading} isWhite />;
  }

  return (
    <div className="trainingClientWrapper">
      <div className="trainingClientHeader">
        <div className="trainingClientNameHeader">
          <h2>Занятие</h2>
          <div className="carryoverBtnHeader" onClick={openGroupSchedule}>
            <img src={Refresh} alt="перенос" /> <span>Перенос</span>{" "}
          </div>
        </div>
        <span>
          Главная &rarr;{" "}
          <Link to={`/client/child/${child_id}`}>{child.first_name}</Link>{" "}
          &rarr; Занятие
        </span>
      </div>
      <div className="trainingClientContent">
        <div className="trainingClientContentDate">
          <div className="contentDateHeader">
            <div className="dateHeader">
              <StatusTraining
                start={schedule.startTime}
                end={schedule.endTime}
                day={schedule.start}
              />
              <h3>{schedule.dataString}</h3>
            </div>
            <div
              className="carryoverBtnHeaderMobile"
              onClick={openGroupSchedule}
            >
              <img src={Refresh} alt="перенос" /> <span>Перенос</span>{" "}
            </div>
          </div>
          <label>
            {schedule.startTime}-{schedule.endTime}
          </label>
          <span>{schedule.group.name}</span>
        </div>
        <div className="trainingClientContentLocation">
          <div className="contentLocationItem">
            <span>Тренер</span>
            <h4>
              {schedule.trainer.first_name} {schedule.trainer.last_name}
            </h4>
          </div>
          <div className="contentLocationItem">
            <span>Адрес</span>
            <h4>{schedule?.filial?.address}</h4>
          </div>
        </div>
      </div>
      <div className="trainingClientEvents">
        <h3>События</h3>
        <div className="trainingClientEventsContent">
          {schedule.history.map((item) => (
            <div
              className="trainingClientEventContainer"
              key={item.id}
              style={colorContainerEvent(item.creator)}
            >
              <label>{item.content}</label>
              <div className="EventContainerFooter">
                <span>{item.creator}</span>
                <span>
                  <NewDate created_at={item.created_at} />
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="clientEventsAction">
          <input
            placeholder="Напишите сообщение..."
            type="text"
            value={content}
            onChange={(e) => setContent(e.target.value)}
          />
          <img src={Arrow} alt="Arrow Icon" onClick={addEvent} />
        </div>
      </div>
      <Dialog
        open={open}
        onClose={() => setOpen(!open)}
        aria-labelledby="form-dialog-schedule"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="form-dialog-schedule" onClose={() => setOpen(!open)}>
          <h3>Перенос занятия</h3>
        </DialogTitle>
        <DialogContent id="form-dialog-schedule-content">
          {loadingGroupSchedule ? (
            <CircularIndeterminate />
          ) : (
            <div>
              <p>
                Перенос занятия вы можете осуществить самостоятельно в рамках
                месяца абонемента
              </p>
              <p>
                Для переноса занятий на другой месяц требуется документ,
                например, справка от врача.
              </p>
              <div className="scheduleSelectDay">
                <label>Выберите день</label>
                <SelectReact
                  inputProps={{ readOnly: true }}
                  isSearchable={false}
                  id="daySchedule"
                  name="daySchedule"
                  placeholder={"Нет свободных"}
                  value={scheduleGroup[0]}
                  styles={customStylesClient}
                  getOptionLabel={(x) => x.value}
                  getOptionValue={(x) => x.value}
                  options={scheduleGroup}
                  onChange={setSelectedDay}
                />
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions id="schedule-action">
          <Button onClick={moveTraining} color="primary" variant="contained">
            Перенести
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withRouter(TrainingClient);
